import Image from "next/image";
import Title from "./Title";
import BreadCrumbs from "../breadcrumb/BreadCrumbs";

const SubTitle = ({
  TitleText,
  mainPage,
  mainPageRoute,
  mainPageName,
  imgUrl,
  pageRoute,
  pageName,
  className,
  mainPageHref,
}) => {
  return (
    <div className={"section_header_page " + className}>
      <BreadCrumbs
        mainPageName={mainPageName}
        mainPage={mainPage}
        mainPageRoute={mainPageRoute}
        pageRoute={pageRoute}
        pageName={pageName}
        mainPageHref={mainPageHref}
      />

      {imgUrl && (
        <div className="page-bg">
          <div className="page-bg-img">
            <Image
              width={1622}
              height={300}
              src={imgUrl}
              alt={TitleText}
              layout="responsive"
              unoptimized
            />
          </div>
          <div className="page-bg-inner">
            {/* <h3>{dataAbout.title}</h3> */}
          </div>
        </div>
      )}

      <Title TitleText={TitleText} />
    </div>
  );
};

export default SubTitle;
